import { render } from "./App.vue?vue&type=template&id=54030aea"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
script.render = render

export default script